import { Popups } from "../popup/popups";
import cookies from "../../plugins/cookies";

class ExitPopup {
	constructor() {}
	init($root = document) {
		this.exitPopupButton = document.querySelector("[data-action=popup_exit]");
		this.submitButton = document.querySelector("[data-submit]");
		this.exitPopupEl = document.querySelector("[data-popup=exit]");
		if (this.exitPopupEl) {
			this.exitPopupTimeout = parseInt(
				this.exitPopupEl.getAttribute("data-popup-timeout")
			);
		}
		this.timeout;
		this.popupShowed = false;

		this.clientRadio = document.querySelectorAll("input[type='radio']");
		this.blockedMessage = document.querySelector("[data-blocked-client] p");
		this.clientRadio.forEach(radio => 
			radio.addEventListener("click", () => {
				if (radio.hasAttribute('data-blocked')) {
					this.blockedMessage.style.display = "block";
					this.submitButton.disabled = true;
						// console.log("this.blockedRadio", radio.checked);
				} else {
					this.submitButton.disabled = false;
					this.blockedMessage.style.display = "none";
				}
			})
		)
		// if (this.blockedMessage.textContent != "" ) {
		// 	this.clientRadio.addEventListener("click", () => {
		// 		this.blockedMessage.textContent = "";
		// 		this.submitButton.disabled = false;
		// 		console.log("this.blockedRadio", this.clientRadio.checked);
		// 	})
		// } else if (this.blockedMessage.textContent == "") {
		// 	this.clientRadio.addEventListener("click", () => {
		// 		this.blockedMessage.textContent = "OFERTA DOSTĘPNA TYLKO DLA OBECNYCH KLIENTÓW";
		// 		this.submitButton.disabled = true;
		// 		console.log("this.blockedRadio", this.clientRadio.checked);
		// 	})
		// }
		// this.blockedRadio.addEventListener("click", () => {
		// 	if (this.blockedRadio.checked) {
			// console.log("this.blockedRadio", this.blockedRadio.checked);
		// 	this.blockedMessage.textContent = "OFERTA DOSTĘPNA TYLKO DLA OBECNYCH KLIENTÓW";
		// } else if (this.blockedMessage.textContent) {
		// 	this.blockedMessage.textContent = "";
		// }
		// })

		const that = this;
		// console.log('exitPopup this', this.exitPopupEl);
		// if (window.innerWidth >= 1200) {
		checkIsMobile();
		// console.log('!document.body.classList.contains(is-mobile)', !document.body.classList.contains('is-mobile') );
		// console.log('!document.body.classList.contains(is-tablet)', !document.body.classList.contains('is-tablet') );
		if (
			!document.body.classList.contains("is-mobile") &&
			!document.body.classList.contains("is-tablet")
		) {
			// window.addEventListener("mouseout", function (event) {
			// 	console.log("exitPopup2", event, event.relatedTarget, event.clientY);
			// 	if (
			// 		event.relatedTarget === null &&
			// 		sessionStorage.getItem("popup_exit") !== "showed" &&
			// 		that.exitPopupButton
			// 	) {
			// 		if (
			// 			!document.body.classList.contains("ie") &&
			// 			!document.body.classList.contains("edge")
			// 		) {
			// 			if (event.clientY < 0) {
			// 				that.exitPopupButton.click();
			// 			}
			// 		} else {
			// 			that.exitPopupButton.click();
			// 		}
			// 	}
			// });
		} else {
			if (
				this.exitPopupTimeout &&
				sessionStorage.getItem("popup_exit") !== "showed"
			) {
				// console.log('exitPopupTimeout', this.exitPopupTimeout);
				this.showPopup();
				window.addEventListener("scroll", function (event) {
					// console.log('exitPopup this', that);
					clearTimeout(that.timeout);
					that.showPopup();
					// console.log('setTimeout scroll');
				});
				window.addEventListener("click", function (event) {
					clearTimeout(that.timeout);
					that.showPopup();
					// console.log('setTimeout');
				});
			}
		}
	}
	showPopup() {
		if (!this.popupShowed) {
			const that = this;
			that.timeout = setTimeout(function () {
				that.exitPopupButton.click();
				clearTimeout(that.timeout);
				that.popupShowed = true;
				// console.log('setTimeout');
			}, that.exitPopupTimeout);
		}
	}
}

const exitPopup = new ExitPopup();

export { exitPopup };
